import EditTargetView from "../../../../../components/AssetManagement/Overview/WebsiteTarget/EditTarget/EditTargetView";

const EditTargetScreen = (userToken: any) => {
  const oauthTokenHeader = userToken?.userToken;
  const Websiteresponse = userToken?.response;
  return (
    <>
      <EditTargetView
        oauthTokenHeader={oauthTokenHeader}
        response={Websiteresponse}
      />
    </>
  );
};

export default EditTargetScreen;
